<template>
    <div>
        <v-container grid-list-lg>
            <v-layout  wrap  row  :justify-center="layoutCalculation">   
                <!--<v-flex xs12 sm12 md12 lg12 v-if="true">
                    <div class="text-xs-center" style="margin-bottom:20px;">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                    </div>
                </v-flex>-->
                <v-flex xs12 sm12 md6 lg4
                    v-for="(item, i) in avt_blagajne" :key="i"
                >
                    <avt-blagajna :id="item.ID"></avt-blagajna>

                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import store from '.././store'

export default {
    data: () => ({

    }),
    
    computed: {
        avt_blagajne() {
            return this.$store.getters.avtBlagajne
        },

        layoutCalculation() {
            let st_blagajn = this.$store.getters.avtBlagajne.length

            if(st_blagajn > 2) {
                return false;
            }

            return true;
        }
    },

    methods: {
        
    },

    created() {
    },

    mounted() {

    }




}
</script>

<style>

</style>


